// ------------------------------------------
// お問い合わせフォーム：水曜日を選択不可（ピッカー上でグレーアウト）
// ------------------------------------------
class ContactDate {
  constructor(el) {
    this.inputs = document.querySelectorAll(el || 'input[type="date"]');
    if (this.inputs.length > 0 && typeof flatpickr !== 'undefined') {
      this.init();
    }
  }

  // 水曜日(3)は定休日
  isWednesday(date) {
    return date.getDay() === 3;
  }

  init() {
    this.inputs.forEach((input) => {
      // ネイティブのdateピッカーが出ないよう、flatpickr側に置き換える
      input.type = 'text';
      input.placeholder = '年 / 月 / 日';
      flatpickr(input, {
        locale: 'ja',
        dateFormat: 'Y-m-d', // 送信される値
        altInput: true, // 画面上の表示用inputを別に生成
        altFormat: 'Y年n月j日',
        altInputClass: 'c-form__date',
        minDate: input.min || null,
        maxDate: input.max || null,
        disable: [(date) => this.isWednesday(date)],
        disableMobile: true,
      });
    });
  }
}
